import { createFileRoute } from '@tanstack/react-router'
import PrivacyPage from '@/pages/privacy'
import { buildHead } from '@/shared/seo/seo-config'

export const Route = createFileRoute('/$lang/privacy')({
  head: ({ params }) => buildHead('privacy', params.lang),
  component: PrivacyPage,
  staticData: { layout: 'public' },
})
